import React from 'react';
import PropTypes from 'prop-types';
import last from 'lodash/last';
import get from 'lodash/get';
import getStatValue from '~/util/getStatValue';

import StyledComponent from '~/components/Styled/Styled';
import CardHeader from '~/components/CardHeader/CardHeader';
import TeamStandingsComparisons from '~/constants/TeamStandingsComparisons';
import css from '~/components/TeamComparisonCard/TeamComparisonCard.scss';

const isHomeFirst = sportName => sportName === 'soccer';
const getTeamName = team => get(team, 'abbreviation', '');
const getAwayStandings = standings => get(standings, 'away', '');
const getHomeStandings = standings => get(standings, 'home', '');

const renderStatLine = statLine => {
  const { firstStat, secondStat, label } = statLine;
  return (
    <div className={`${css.statLine}`} key={label}>
      <div>{firstStat}</div>
      <div className={`${css.label}`}>{label}</div>
      <div>{secondStat}</div>
    </div>
  );
};

const formatStatLines = (firstTeam, secondTeam, leagueSlug) => {
  const standingComparisons = TeamStandingsComparisons[leagueSlug];

  return standingComparisons.map(comparison => {
    const label = comparison.label;

    const firstStat = getStatValue(firstTeam, `[${comparison.keys[0]}]`);
    const secondStat = getStatValue(secondTeam, `[${last(comparison.keys)}]`);

    return {
      label,
      firstStat,
      secondStat,
    };
  });
};

class TeamComparisonCard extends React.PureComponent {
  render() {
    const { league, away_team, home_team, standings } = this.props.event;

    if (!standings) {
      return null;
    }

    const homeFirst = isHomeFirst(league.sport_name);
    const firstTeamName = homeFirst ? getTeamName(home_team) : getTeamName(away_team);
    const secondTeamName = homeFirst ? getTeamName(away_team) : getTeamName(home_team);
    const firstTeamStandings = homeFirst
      ? getHomeStandings(standings)
      : getAwayStandings(standings);
    const secondTeamStandings = homeFirst
      ? getAwayStandings(standings)
      : getHomeStandings(standings);

    const statLines = formatStatLines(firstTeamStandings, secondTeamStandings, league.slug);

    return (
      <div>
        <div className={css.title}>Team Comparison</div>
        <CardHeader disableFlex>
          <div className={`${css.header}`}>
            <div>{firstTeamName}</div>
            <div />
            <div>{secondTeamName}</div>
          </div>
        </CardHeader>
        <div>{statLines.map(statLine => renderStatLine(statLine))}</div>
      </div>
    );
  }
}

TeamComparisonCard.propTypes = {
  event: PropTypes.shape({
    league: PropTypes.shape({
      sport_name: PropTypes.string,
      slug: PropTypes.string,
    }).isRequired,
    away_team: PropTypes.shape({
      short_name: PropTypes.string,
    }),
    home_team: PropTypes.shape({
      short_name: PropTypes.string,
    }),
    standings: PropTypes.shape({
      away: PropTypes.object,
      home: PropTypes.object,
    }).isRequired,
  }).isRequired,
};

TeamComparisonCard.displayName = 'TeamComparisonCard';

export default StyledComponent(TeamComparisonCard, [css]);
